// DynamicForm.js
import React, { useState, useEffect } from 'react';
import ProjectData from './ProjectData';

const DynamicForm = () => {
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [fetchStatus, setFetchStatus] = useState('loading');

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await fetch(process.env.PUBLIC_URL + '/task1.json');
        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.statusText}`);
        }
        const jsonData = await response.json();
    
        console.log('Fetched JSON data:', jsonData);
    
        // Assuming jsonData has a property named "questions"
        const data = jsonData.questions;
    
        if (Array.isArray(data)) {
          setQuestions(data);
          setFetchStatus('loaded');
        } else {
          console.error('Invalid JSON structure: Expected an array.');
          setFetchStatus('failed');
        }
      } catch (error) {
        console.error('Error fetching or parsing JSON data:', error.message);
        setFetchStatus('failed');
      }
    };

    fetchQuestions();
  }, []);

  const handleTextAreaChange = (questionId, subquestionIndex, value) => {
    setResponses(prevResponses => ({
      ...prevResponses,
      [questionId]: {
        ...prevResponses[questionId],
        [subquestionIndex]: value,
      },
    }));
  };

  const renderFormFields = () => {
    return questions.map((question, index) => (      
      <div key={index} className="form-question mb-5 xborder xborder-theme-primary-4 xp-2 xpx-3 xbg-theme-primary-2">
        <h6 className='font-secondary mb-2 size-lg'>{`${question.id}. ${question.category}`}</h6>
        {question.subquestions.map((subquestion, subIndex) => (
          <div key={subIndex}>
            <p className='size-md mb-2'>{subquestion} </p>
            <textarea rows="4"
              value={responses[question.id]?.[subIndex] || ''}
              onChange={(e) => handleTextAreaChange(question.id, subIndex, e.target.value)}
              className='size-md text-theme-primary-16 w-100 p-2 mb-4 border border-theme-primary-8 rounded-0'
              style={{lineHeight:'145%'}}
            />
          </div>
        ))}
      </div>
    ));
  };

  const renderFetchStatus = () => {
    switch (fetchStatus) {
      case 'loading':
        return <p>Loading...</p>;
      case 'loaded':
        return (
          <>
          <div className=''>
          {renderFormFields()}
          </div>
          </>
        );
      case 'failed':
        return <p>Failed to fetch JSON data.</p>;
      default:
        return null;
    }
  };

  return (
    <div className="dynamic-form container-xl p-2">
      
      {renderFetchStatus()}
      <div className='text-end'>
      <a className='theme-button theme-button-primary' onClick={() => console.log('Saved responses:', responses)}>Save</a>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <div className='size-md' style={{lineHeight:'140%'}}><ProjectData/></div>
    </div>
  );
};

export default DynamicForm;